import React from "react"
import UIkit from 'uikit';
import 'uikit/dist/css/uikit.css';
import "../scss/components/steps-component.scss" 
import CustomMarkdown from "../utils/customMarkdown"
 
const StepsComponent = ({stepsList, sectionStyle="white"}) => { //, title, description
    const componentBgClass = sectionStyle =="white" ? "white-section" : "dark-section";
    if(stepsList != null){
        return(
            <div className={componentBgClass + " steps-component padding-top padding-bottom"}>
                <div>
                    {
                    stepsList.map((item, index) => {           
                        return(
                            <div key={index} className="step-row">   
                                <div className="uk-padding-none uk-grid desktop-grid">         
                                    <div className="uk-width-1-5 step-title">
                                        <h3>{item.Title}</h3>
                                    </div>
                                    <div className="uk-width-1-5 timeline-container desktop-timeline">
                                        <div class="timeline-line"></div>
                                        <div class="timeline-step"></div>
                                    </div>
                                    <div className="uk-width-3-5 step-description">
                                        <CustomMarkdown key={index} children={item.StepDescription} />
                                    </div>
                                </div>
                                {/* below is the mobile version of steps with timeline grid */}
                                <div className="uk-padding-none uk-grid mobile-grid">  
                                    <div className="uk-width-1-6 timeline-container desktop-timeline">
                                        <div class="timeline-line"></div>
                                        <div class="timeline-step"></div>
                                    </div>       
                                    <div className="uk-width-expand step-description"><h3>{item.Title}</h3>  <CustomMarkdown key={index} children={item.StepDescription} /></div>
                                </div>
                            </div>
                        )
                    })
                    }
                </div>
    
            </div>
        )
    }else{
        return('')
    } 
    
}
export default StepsComponent